import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './app_store/reducers';

const store = configureStore({
    reducer: rootReducer,
});
export default store;
